import { OtherScoresState } from "./types";

const state: OtherScoresState = {
  arrayIds: [],
  reports: {},
  intervalId: 0,
};

export default state;
